
















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IAffiliate } from "@/models/affiliate";
import { IInvoice } from "@/models/invoices";
import HasValidation from "@/mixins/HasValidation";

type IRejectForm = {
  affiliate_commission_invoice_ids: IInvoice["id"][];
  reject_reason: string;
};

@Component
export default class RejectAffiliateCommissionModal extends Mixins(
  HasValidation
) {
  // Props

  @Prop({ required: true })
  public affiliateAccountId!: IAffiliate["id"][];

  @Prop({ required: true })
  public amount!: number;

  @Prop({ required: true })
  public invoiceIds!: IInvoice["id"][];

  // Data

  public form = {} as IRejectForm;
  public isProcessing = false;

  // Computed

  public get formIsDisabled() {
    return this.isProcessing || this.hasErrors;
  }

  // Lifecycle methods

  public async created() {
    this.form = this.initForm();
  }

  // Methods

  public initForm(): IRejectForm {
    return {
      affiliate_commission_invoice_ids: this.invoiceIds,
      reject_reason: ""
    };
  }

  public async rejectCommission() {
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/reject`,
      {
        affiliate_account_id: this.affiliateAccountId,
        data: this.form
      }
    );
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;
    try {
      this.isProcessing = true;
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      await this.rejectCommission();
      this.$emit("success");
      this.$emit("close");
      this.$buefy.toast.open({
        message: this.$t("_.commission_rejected") as string
      });
    } catch (error) {
      this.isProcessing = false;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
